import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { PocList } from 'commons/components/components-wrapper/poc-list.component';
import { PocListItem } from 'commons/components/components-wrapper/poc-list-item.component';
import { AlarmsBadgeComponent } from 'commons-app/components';
import { useAppContext } from 'core/contexts/app.provider.context';
import { useUserPreferencesContext } from 'core/contexts/user-preferences/hooks/use-user-preferences-context.hook';
import { useTranslation } from 'core/i18n';
import { UserCustomFilter, UserCustomFilterTypes } from 'core/utils/types/user-custom-filter.type';
import { DevicesFilterFields } from 'modules/devices/domain';
import { getFilterByFieldValue } from '../app.menu.business';
import { SideMenuListItem } from '../app.menu.style';
import { MenuProps } from '../app.menu.type';
import { MenuFilterItem } from './filter-item-menu.component';

export const DevicesMenu: React.FC<MenuProps> = ({ selected, menuVisible, onNavigationClick, onExpandedChange }) => {
    const { t } = useTranslation();
    const { sideMenuAlarms } = useAppContext();
    const { sideMenuEntries } = useUserPreferencesContext();

    const handleClick = (e: React.MouseEvent<HTMLElement>) => {
        if ((e.target as HTMLElement).closest('owc-icon-button')) {
            return;
        }
        onNavigationClick('devices');
    };

    const handleExpand = () => {
        onExpandedChange?.(!menuVisible);
    };

    return (
        <SideMenuListItem
            value="devices"
            data-testid="devices-menu-item"
            variant="side-menu"
            selected={selected === `devices`}
            onClick={handleClick}
            onExpandedChange={handleExpand}
            size="medium"
            expanded={menuVisible}
        >
            <PocIcon slot="prefix" name="poc_devices" family="filled" data-testid="devices-icon" />
            {t('app.sidemenu.options.devices')}
            <div slot="suffix" style={{ marginRight: '8px' }}>
                <AlarmsBadgeComponent alarms={sideMenuAlarms['devices']} type="DEVICES" />
            </div>
            <PocList slot="children">
                {sideMenuEntries
                    ?.filter((filter: UserCustomFilter<DevicesFilterFields>) =>
                        getFilterByFieldValue?.(filter, UserCustomFilterTypes.DEVICES, 'active', true)
                    )
                    .map((sideMenuEntry) => (
                        <MenuFilterItem
                            key={sideMenuEntry.id}
                            filter={sideMenuEntry}
                            module={UserCustomFilterTypes.DEVICES}
                            sideMenuAlarms={sideMenuAlarms}
                            showBadge={true}
                        />
                    ))}
                <PocListItem
                    variant="side-menu"
                    value="devices/filters/deactivate"
                    data-testid="devices-deactivated-menu-item"
                    size="medium"
                    className={selected === `devices/filters/deactivate` ? 'selected' : ''}
                >
                    {t('app.sidemenu.options.devices.deactivated')}
                </PocListItem>
                {sideMenuEntries
                    ?.filter((filter: UserCustomFilter<DevicesFilterFields>) =>
                        getFilterByFieldValue?.(filter, UserCustomFilterTypes.DEVICES, 'active', false)
                    )
                    .map((sideMenuEntry) => (
                        <MenuFilterItem
                            key={sideMenuEntry.id}
                            filter={sideMenuEntry}
                            module={UserCustomFilterTypes.DEVICES}
                            sideMenuAlarms={sideMenuAlarms}
                            showBadge={false}
                        />
                    ))}
            </PocList>
        </SideMenuListItem>
    );
};
